<template>
  <div class="c-epg-calendar">
    <i
      class="o-icon o-icon--left o-typography--action c-epg-calendar__arrow"
      @click="prev"
    ></i>

    <div
      ref="slider"
      class="c-epg-calendar__slider"
    >
      <div class="c-epg-calendar__wrapper js-slider-wrapper">
        <div
          v-for="day in days"
          class="c-epg-calendar__item js-slider-item"
          :class="{ 'is-active': epgTime.today.isSame(day, 'day') }"
          @click.prevent="changeDay(day)"
        >
          <div class="c-epg-calendar__label">
            <template v-if="epgTime.now.isSame(day, 'day')">
              {{ $t('glossary.today') }}
            </template>
            <template v-else>
              {{ day | dateFormat('ddd') }}
            </template>
          </div>
          <div
            v-if="withDates"
            class="c-epg-calendar__date"
          >
            {{ day | getFormatedShortDate }}
          </div>
        </div>
      </div>
    </div>

    <i
      class="o-icon o-icon--right o-typography--action c-epg-calendar__arrow"
      @click="next"
    ></i>
  </div>
</template>

<script>
  import Slider from '@/shared/libs/slider';
  import { dateFormat, getFormatedShortDate } from '@/index/shared/filters';

  const DAYS_AHEAD = 6;
  const DAYS_BEHIND = 6;

  export default {
    name: 'EpgCalendar',
    filters: {
      dateFormat,
      getFormatedShortDate,
    },
    props: {
      epgTime: undefined,
      withDates: undefined,
    },
    data() {
      return {
        days: [],
        slider: null,
      };
    },
    watch: {
      'epgTime.dayOffset': function () {
        this.reset();
      },
    },
    mounted() {
      this.initCalendar();
    },
    methods: {
      initCalendar() {
        const now = this.epgTime.now;

        this.days.push(now);

        for (let i = 0; i < DAYS_AHEAD; i++) {
          this.days.push(now.clone().add(i + 1, 'day'));
        }

        for (let i = 0; i < DAYS_BEHIND; i++) {
          this.days.unshift(now.clone().subtract(i + 1, 'day'));
        }

        this.$nextTick(() => {
          this.slider = Slider(this.$refs.slider, {
            step: 1,
            duration: 200,
            index: this.days.indexOf(now),
          });

          this.goToNow();
        });
      },
      next() {
        this.slider.next();
      },
      prev() {
        this.slider.prev();
      },
      goToNow() {
        if (this.$window.isMobileView) {
          this.slider.slideTo(DAYS_BEHIND - 1);
        } else {
          this.slider.slideTo(DAYS_BEHIND - 2);
        }
      },
      reset() {
        let slideTo;
        if (this.$window.isMobileView) {
          slideTo = DAYS_BEHIND - 1;
        } else {
          slideTo = DAYS_BEHIND - 2;
        }

        slideTo += this.epgTime.dayOffset;
        this.slider.slideTo(slideTo);
      },
      changeDay(day) {
        this.epgTime.dayOffset = day.startOf('day').diff(this.epgTime.now.clone().startOf('day'), 'days');
      },
    },
  };
</script>
